import { render, staticRenderFns } from "./PatrimonioDashboard.vue?vue&type=template&id=3f3b1889&scoped=true"
import script from "./PatrimonioDashboard.vue?vue&type=script&lang=js"
export * from "./PatrimonioDashboard.vue?vue&type=script&lang=js"
import style0 from "./PatrimonioDashboard.vue?vue&type=style&index=0&id=3f3b1889&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b1889",
  null
  
)

export default component.exports